var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.showPage),expression:"!showPage"}],staticClass:"w-full h-full",attrs:{"id":"app"}},[(_vm.showPage)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }